module.exports = __webpack_public_path__ + "assets/img/ddbes_asset.3563e45e.png";